<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showSnackBar" color="red" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <ServerError v-if="ServerError" />
    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              cropwidth="400"
              cropheight="300"
              :key="currentImage"
              @stepper="imageCropper"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex px-5 pt-5 py-5 xs12 sm12 md12 lg12 xl12>
        <v-card>
          <v-card-title class="elevation-1">
            Edit Product
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="profileForm" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :rules="Rules"
                      v-model="productname"
                      label="Product Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field
                      :rules="Rules"
                      v-model="price"
                      label="Product Cost"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="3">
                    <v-select
                      dense
                      multiple
                      v-model="category"
                      class="mt-5"
                      readonly
                      label="Category"
                      :items="categoryArray"
                      item-text="name"
                      item-value="_id"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      dense
                      class="mt-5"
                      label="Sub-category"
                      v-model="subcategory"
                      :items="subcategoryArray"
                      item-text="name"
                      item-value="_id"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="stockQuantity"
                      label="Stock Quantity"
                      :disabled="user.isColor ? true : false"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      :rules="Rules"
                      v-model="discount"
                      label="Discount"
                    ></v-text-field>
                  </v-col>
                  <v-layout wrap v-if="user.categoryId">
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                      v-if="user.categoryId._id == '601e2b174b2e12e49fd4da3c'"
                    ><v-select
                        v-model="type"
                        placeholder="Product Type"
                        dense
                        class="mt-5"
                        hide-details
                        :items="foodtype"
                      ></v-select>
                    </v-col>
                  </v-layout>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="specification" label="Specification">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      :rules="Rules"
                      v-model="description"
                      label="Description"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-layout wrap>
                  <v-flex md3 lg3 pl-3 text-left>
                    <v-card pr-4flat tile outlined>
                      <v-layout wrap>
                        <v-flex pl-2 md8 lg8>
                          <v-layout wrap>
                            <v-flex
                              pt-2
                              md6
                              v-for="(item, i) in user.photos"
                              :key="i"
                              px-2
                              class="hidden-sm-and-down"
                            >
                              <v-badge small overlap avatar color="#FF1313">
                                <template v-slot:badge>
                                  <v-avatar>
                                    <v-icon small @click="removePhotos(i)"
                                      >mdi-close</v-icon
                                    >
                                  </v-avatar>
                                </template>
                                <v-img
                                  v-if="item"
                                  :src="baseURL + '/file/get/' + item"
                                  height="44px"
                                  width="44px"
                                  contain
                                >
                                </v-img>
                              </v-badge>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex
                              lg6
                              md6
                              v-for="(item, i) in imageArray"
                              :key="i"
                              px-2
                              class="hidden-sm-and-down"
                            >
                              <v-badge small overlap avatar color="#FF1313">
                                <template v-slot:badge>
                                  <v-avatar>
                                    <v-icon small @click="removeImageArray(i)"
                                      >mdi-close</v-icon
                                    >
                                  </v-avatar>
                                </template>
                                <v-img :src="item" height="44px" width="44px">
                                </v-img>
                              </v-badge>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                    <br />
                    <span>
                      <v-btn
                        small
                        :ripple="false"
                        id="pro_pic"
                        class="text-capitalize"
                        color="#EFEFEF "
                        width="80%"
                        @click="$refs.files.click()"
                      >
                        <span style="font-size: 12px">Upload Image</span>
                      </v-btn>
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="files"
                        multiple="multiple"
                        type="file"
                        @change="uploadImages"
                      />
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout justify-center wrap pt-5>
                  <v-flex xs12 v-if="user">
                    <v-layout wrap v-if="user.colorDetails">
                      <v-flex
                        xs12
                        md12
                        lg10
                        xl7
                        v-if="
                          user.colorDetails.length > 0 &&
                          user.categoryId._id == '5fdc6f06de6a0c4260faa143'
                        "
                      >
                        <v-layout wrap justify-center v-if="subCats.length > 0">
                          <v-flex xs12 text-left>
                            <span>Product Stock/Color Details</span>
                          </v-flex>
                          <v-flex xs12>
                            <StockAdder
                              v-bind:storage="subCats"
                              v-bind:sizeData="user.size"
                              v-bind:isColor="user.isColor"
                              :key="subSizeArray[0]"
                              @stepper="winStepper"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg10
                        xl7
                        v-if="
                          user.colorDetails.length <= 0 &&
                          user.categoryId._id == '5fdc6f06de6a0c4260faa143'
                        "
                      >
                        <v-layout wrap justify-center>
                          <v-flex xs12 text-left>
                            <span class="styloopinputlabel"
                              >Color Available</span>
                          </v-flex>
                          <v-flex xs12>
                            <StockAdder @stepper="winStepper" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-row class="justify-center">
                  <v-btn
                    :disabled="!valid"
                    outlined
                    color="red"
                    @click="validate()"
                  >
                    Update
                  </v-btn>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ImageCropper from "@/components/commonComponents/imageCropper";
import axios from "axios";
import StockAdder from "./mystockAdder";
export default {
  components: {
    StockAdder,
    ImageCropper,
  },
  data() {
    return {
      deleteImageArrayDialog: false,
      imageArray: [],
      Images: new FormData(),
      formData: new FormData(),
      delFormData: new FormData(),
      selectedFiles: null,
      i: null,
      ServerError: false,
      specification: "",
      description: "",
      file: null,
      image: "",
      productStock: {},
      tagDialog: false,
      materialDialog: false,
      sizeDialog: false,
      appLoading: false,
      showSnackBar: false,
      productcode: null,
      productname: null,
      price: null,
      discount: null,
      stockQuantity: null,
      category: [],
      categoryArray: [],
      subcategoryArray: [],
      subcategory: null,
      msg: null,
      valid: true,
      flag: false,
      isColor: false,
      type: "",
      user: [],
      Rules: [(v) => !!v || "Required"],
      foodtype: ["Vegetarian", "Non-vegetarian", "Eggetarian"],
      imageCount: 0,
      cropImageDialog: false,
      currentImage: null,
      subCats: "",
      subSizeArray: [],
      ColorDetails: [],
    };
  },
  computed: {
    appCategory() {
      return this.$store.state.categoryId;
    },
  },
  watch: {
    category() {
      this.getSubcategory();
    },
  },
  mounted() {
    this.getData();
    this.getCategory();
    // this.getSubcategory();
  },
  methods: {
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    collectImages(image) {
      this.selectedFiles = image;
      this.Images.append("image", this.selectedFiles);
      this.formData.append("photos", this.selectedFiles);
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);
        this.imageCount = this.product.photos.length + this.imageArray.length;
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    winStepper(window_data) {
      this.productStock = window_data.productStock;

      this.user.size = this.productStock;
      // console.log("Filtered=", this.productStock);
      this.user.stockQuantity = 0;
      // for (var i = 0; i < this.productStock.length; i++) {
      //   for (var j = 0; j < this.productStock[i].stock.length; j++) {
      //     this.product.stockQuantity =
      //       this.product.stockQuantity + this.productStock[i].stock[j].stock;
      //   }
      // }
      this.user.stockQuantity = JSON.parse(window_data.total);
      if (window_data) {
        this.flag = window_data.haveTotal;
        this.user.isColor = window_data.haveTotal;
        this.colorData = window_data.productStock;
        // console.log("new ", this.colorData);
      }
    },
    validate() {
      if (this.$refs.profileForm.validate()) {
        this.editProduct();
      }
    },
    getCategory() {
      this.appLoading = true;
      axios({
        url: "/category/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    subSize(id) {
      for (var i = 0; i < this.subcategoryArray.length; i++) {
        if (id == this.subcategoryArray[i]._id) {
          this.subSizeArray = this.subcategoryArray[i].size;
          this.singleSubcatData = this.subcategoryArray[i];
        }
      }
    },
    getSubcategory() {
      axios({
        url: "/subcategory/list/" + this.category,
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.subcategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/seller/product/view/" + this.$route.query.product,
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.productname = this.user.name;
          this.price = this.user.price;
          this.discount = this.user.discount;
          this.stockQuantity = this.user.stockQuantity;
          this.specification = this.user.specification;
          this.description = this.user.description;
          this.category = this.user.categoryId._id;
          this.subCats = this.user.colorDetails;
          this.subcategory = this.user.subcategoryId._id;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removePhotos(i) {
      var Data = {};
      var name = [];
      name.push(this.user.photos[i]);
      this.user.photos.splice(i, 1);
      Data["id"] = this.$route.query.product;
      Data["key"] = name;
      axios({
        method: "POST",
        url: "/admin/product/photos/delete",
        data: Data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = "Deleted Successfully";
            this.getData();
          } else {
            this.msg = "Can't Delete Image";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      console.log(this.formData);
      this.imageArray.splice(i, 1);
      this.deleteImageArrayDialog = false;
    },
    uploadImages(event) {
      if (this.imageCount < 4) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;
        return;
      }
    },
    uploadEditedImages() {
      this.formData.append("id", this.$route.query.product);
      axios({
        method: "POST",
        url: "/admin/seller/product/edit",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.formData = new FormData();
            this.selectedFiles = null;
            this.msg = "Upload Successfully";
            this.showsnackbar = true;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editProduct() {
      this.appLoading = true;
      var user = {};
      user["name"] = this.productname;
      user["price"] = this.price;
      user["subcategoryId"] = this.subcategory;
      user["specification"] = this.caption;
      user["description"] = this.description;
      user["discount"] = this.discount;
      user["id"] = this.$route.query.product;
      user["type"] = this.type;
      user["stockQuantity"] = Number(this.stockQuantity);
      user["isColor"] = this.user.isColor;
      if (this.user.stockQuantity > 0) this.user.instock = true;
      if (
        this.user.categoryId._id == "5fdc6f06de6a0c4260faa143" &&
        this.user.isColor
      ) {
        user["colorDetails"] = this.colorData;
        user["colorDetails"] = this.user.colorDetails.map((y) => {
          y.colorSave = y.color;
          y.color = y.color.substring(1);
          y.color = "ff" + y.color;
          y.colorHex = JSON.parse(JSON.stringify(y.color));
          y.colorHex = parseInt(y.color, 16);
          y.color = y.colorHex;
          return y;
        });
      }
      axios({
        method: "POST",
        url: "/admin/seller/product/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            if (this.selectedFiles) this.uploadEditedImages();
            this.getData();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>